<div #rootNode class="transport-log" [ngClass]="componentSizeStyle">

  <div class="action-bar" [formGroup]="detailsForm">
    <mat-checkbox name="showLogEntryKeys" formControlName="showLogEntryKeys" *ngIf="allowLogEntryKeySelection">
      {{'show log entry keys' | translate: ['tmc.transport-details.dialog.protocol.action.show-log-entry-keys',
      translationService.language]}}
    </mat-checkbox>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button class="clipboard-button" (click)="copyLogToClipboard()"
      [matTooltip]="'copy to clipboard' | translate: ['tmc.transport-details.dialog.protocol.action.copy-to-clipboard', translationService.language]">
      <sc-icon iconClass="fa-copy"></sc-icon>
    </button>
  </div>
  <div class="log-entries text-selection" id="logTable">
    <div class="log-entries-layout">

      <div class="log-entries-container list-heading">
        <div class="routing-container">
          <div class="routing-detail-heading">
            {{'position'| translate:['tmc.transport-details.dialog.protocol.table.column.position',
            translationService.language]}}
          </div>
        </div>
        <div class="log-details-container">
          <div class="log-detail-row">
            <div class="log-detail-heading">
              {{'transportLog'| translate:['tmc.transport-details.dialog.protocol.table.column.transportLog',
              translationService.language]}}
            </div>
          </div>
        </div>
      </div>

      <div id="log-entries" class="log-entries-scrollable">

        <ng-container *ngFor="let rp of routingPositions">
          <div class="log-entries-container">
            <div class="routing-container">
              <div class="routing-detail" *ngIf="rp.stationName">
                <div class="label">{{'' | translate: ['tmc.transport-details.dialog.stationName',
                  translationService.language]}}</div>
                <sc-content-spacer></sc-content-spacer>
                <div class="value">{{ rp.stationName}}</div>
              </div>
              <div class="routing-detail" *ngIf="rp.cargo">
                <div class="label">{{'' | translate: ['tmc.transport-details.dialog.cargo',
                  translationService.language]}}</div>
                <sc-content-spacer></sc-content-spacer>
                <div class="value">{{ rp.cargo}}</div>
              </div>
              <div class="routing-detail" *ngIf="rp.positionStatus">
                <div class="label">{{'' | translate: ['tmc.transport-details.dialog.positionStatus',
                  translationService.language]}}
                </div>
                <sc-content-spacer></sc-content-spacer>
                <div class="value">{{
                  rp.positionStatus | translate: ['tmc.transport-details.dialog.positionStatus.'+rp.positionStatus,
                  translationService.language]}}</div>
              </div>
              <div class="routing-detail" *ngIf="rp.actionType">
                <div class="label">{{'' | translate: ['tmc.transport-details.dialog.actionType',
                  translationService.language]}}
                </div>
                <sc-content-spacer *ngIf="rp.actionType"></sc-content-spacer>
                <div class="value">{{
                  rp.actionType| translate: ['tmc.transport-details.dialog.actionType.'+rp.actionType,
                  translationService.language]}}</div>
              </div>
            </div>
            <sc-content-spacer [vertical]="true"
              *ngIf="rp.stationName || rp.cargo || rp.positionStatus || rp.actionType"></sc-content-spacer>
            <div class="log-details-container">
              <ng-container *ngFor="let entry of rp.LogEntryViews; let i = index">
                <div class="log-detail-row">
                  <div class="log-detail-execution-type" *ngIf="entry.executionType">
                    {{entry.executionType}}
                  </div>
                  <sc-content-spacer></sc-content-spacer>
                  <div class="log-detail-timestamp" *ngIf="entry.timestamp">
                    {{entry.timestamp}}
                  </div>
                  <sc-content-spacer></sc-content-spacer>
                  <div class="log-detail-log">
                    <div class="log-detail-log-layout">
                      <span *ngIf="entry.logActivityTypeTranslated">
                        {{entry.logActivityTypeTranslated}}
                      </span>
                      <span *ngIf="entry.logActivityTypeTranslated && entry.text"> &nbsp; - &nbsp; </span>
                      <span class="log-detail-text" *ngIf="entry.text">
                        {{entry.text}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="log-detail-row" *ngIf="showLogEntryKeys  && entry.hashKey">
                  <sc-content-spacer [grow]="true"></sc-content-spacer>
                  <span class="log-id">{{'key'| translate:['tmc.transport-details.dialog.key',
                    translationService.language]}}{{': ' +
                    entry.hashKey}}</span>
                  <sc-content-spacer></sc-content-spacer>
                  <button mat-stroked-button class="clipboard-button" (click)="copyLogKeyToClipboard(entry.hashKey)"
                    [matTooltip]="'copy to clipboard' | translate: ['tmc.transport-details.dialog.protocol.action.copy-to-clipboard', translationService.language]">
                    <sc-icon iconClass="fa-copy"></sc-icon>
                  </button>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="log-entry-container-spacer">
            <div class="visible-container"></div>
          </div>

        </ng-container>
      </div>

    </div>
  </div>

  <div class="add-note-container no-field-space">
    <div class="add-note-container-layout">
      <mat-form-field class="note-input">
        <input matInput [(ngModel)]="noteModel" name="orderReference" #orderReferenceCtrl="ngModel"
          placeholder="{{'note' | translate: ['tmc.transport-details.dialog.protocol.note', translationService.language]}}"
          [maxlength]="255" [disabled]="loading">
      </mat-form-field>
      <sc-content-spacer></sc-content-spacer>
      <button mat-stroked-button (click)="addNote()"
        [disabled]="loading || this.routingPositions.length === 0 || this.noteModel.length === 0">
        {{'send' | translate:['tmc.transport-details.dialog.protocol.action.addNote',
        translationService.language]}}
      </button>
    </div>
  </div>
</div>
